import {
  getSubscriptionPlans,
  purchaseSubscription,
  completeSubscription3ds,
  getGatewayActive,
  verifyCouponCode,
  fetchPaypalAccessToken,
  createPaypalSubscription,
  createPaypalSubscriptionPlan,
  getPaypalSubscriptionDetails,
  checkOrCreatePaypalProduct,
} from "../../../services/paymentService";
import { register } from "../../../services/authService";
import { redirectTo } from "../../../utils/httpHelper";
import { showAlert } from "../../../utils/domHelper";
import { durationUnit } from "../../../utils/appHelper";

let cardElement = null;
let stripe = null;
let plans = [];
let selectedPlan = null;

export default async function (baseUrl, tenantId, cb) {
  const { firstName, lastName, userName, email, password, plan } = cb._data;
  const activeGW = await getGatewayActive(baseUrl, tenantId);

  let payload = {
    first_name: firstName,
    last_name: lastName,
    username: userName,
    email: email,
    password: password,
    plan_id: plan,
    uuid: plan,
  };

  let coupon_code = cb._data?.coupon_code || document.querySelector("#coupon-code")?.value?.trim();
  if (!coupon_code) {
    const input = document.querySelector("#coupon-code");
    if (input) {
      coupon_code = input.value.trim();
    }
  }

  if (coupon_code && coupon_code.trim() !== "") {
    payload["coupon_code"] = coupon_code.trim();
  }

  // PAYPAL (gateway_provider == 1)
  if (activeGW.gateway_provider == 1) {
    await startCustomPaypalFlow({
      baseUrl,
      apiKey: tenantId,
      client_id: activeGW.credential_information.client_id,
      client_secret: activeGW.credential_information.client_secret,
      plan: plans.find(p => p.uuid === plan),
      firstName,
      lastName,
      email,
      password,
      onLogin: () => redirectTo(),
    });

    cb.emit("submitDone", "");
    return;
  }

  // STRIPE (gateway_provider == 2)
  if (activeGW.gateway_provider == 2 && cardElement && stripe) {
    if (selectedPlan && !selectedPlan.is_free) {
      payload["payment_method_id"] = await stripeCard(cb._data);
      if (!payload["payment_method_id"]) {
        showAlert("Card details are not correct");
        cb.emit("submitDone", "");
        return;
      }
    }
  }

  const resJson = await purchaseSubscription(baseUrl, tenantId, JSON.stringify(payload));

  if (resJson?.requires_action && resJson?.client_secret) {
    if (!stripe) {
      cb.emit("submitDone", "");
      showAlert("Payment form is still loading. Please wait a moment and try again.");
      return;
    }
    // 3D Secure: do NOT emit submitDone until after bank challenge completes
    const { error } = await stripe.confirmCardPayment(resJson.client_secret);
    if (error) {
      cb.emit("submitDone", "");
      showAlert(error.message || "Payment could not be completed.");
      return;
    }
    const completeRes = await completeSubscription3ds(baseUrl, tenantId, resJson.subscription_id);
    if (completeRes?.error) {
      cb.emit("submitDone", "");
      return;
    }
    if (completeRes?.credentials) {
      localStorage.setItem("loginToken", JSON.stringify(completeRes.credentials));
    }
    cb.emit("submitDone", "");
    redirectTo();
    return;
  }

  cb.emit("submitDone", "");
  if (resJson?.credentials) {
    localStorage.setItem("loginToken", JSON.stringify(resJson.credentials));
    redirectTo();
  }
}

// Plans Dropdown
export const singupPlansField = async (baseUrl, apiKey, channelId) => {
  const jsonPlans = await getSubscriptionPlans(baseUrl, apiKey, channelId, {});
  let sub_plans = [];

  if (jsonPlans?.length > 0) {
    plans = jsonPlans;

    $.each(jsonPlans, function (index, value) {
      sub_plans.push({
        value: value.uuid,
        label: value.is_free
          ? value.title
          : `${value.title} ($${value.price} Per ${durationUnit(value.expires_in)})`,
      });
    });

    let defaultSelectedPlan = sub_plans.length === 1 ? sub_plans[0].value : null;
    let planLabel = sub_plans.length === 1 ? sub_plans[0].label : null;

    const selectComponent = {
      type: "select",
      label: sub_plans.length === 1 ? planLabel : "Select a Plan",
      key: "plan",
      placeholder: "Select Plan",
      customClass: sub_plans.length === 1 ? "non-clickable-select" : "",
      data: { values: sub_plans },
      dataSrc: "values",
      template: "<span>{{ item.label }}</span>",
      input: true,
      defaultValue: defaultSelectedPlan,
    };

    return selectComponent;
  }

  return null;
};

// Add CSS using jQuery to a parent box with class "form-content-wrapper"
$(document).ready(function () {
  const customCss = `
    /* Style the form container */
    #idwu {
      left: auto !important;
      display: none !important;
    }
    .block-wrapper-container {
      display: flex !important;
      flex-direction: column;
      align-items: center;
    }
    .formio-form {
      display: flex;
      flex-direction: column;
      align-content: center;
    }
    .formio-component {
      width: 100% !important;
    }
    .form-content-wrapper {
      display: flex;
      justify-content: center;
      padding: 30px;
      border-radius: 10px;
      background-color: #ffffff!important;
      box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.19);
      width: 600px;
      margin:auto;
      padding-bottom: 20px!important;
      padding-top: 40px!important;
    }

    /* Style form labels */
    .form-group label {
      font-weight: bold;
      color: #000000;
      font-size: 16px;
    }

    #stripe-card-fields label {
    font-weight: bold;
    color: #000000;
    font-size: 16px;
    margin-bottom:0px!important;
    }

    /* Style text inputs */
    .form-content-wrapper input ,  .form-content-wrapper .form-control, #stripe-card-element{
      background-color: #d5e5fb!important;
      width: 100%!important;
      padding: 10px!important;
      border-radius: 5px!important;
      border:0px!important;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    #stripe-card-fields{
      margin: 2px;
     margin-top: 0px!important;
    }
    .form-content-wrapper .btn{
      background-color: #00182E;
      border-color: #00182E;
      padding: 12px 20px;
      font-size:18px!important;
      display: flex;
      justify-content: center;
      align-items: center;
      opacity:1;
    }

    .form-content-wrapper p{
      color:#000000!important;
      margin-top: 4px!important;
    }
    .form-content-wrapper a{
      color:#000000!important;
      text-decoration: none!important;
    }
    /* Additional styles for .non-clickable-select */
    .form-content-wrapper .non-clickable-select {
      cursor: default;
      pointer-events: none;
    }
    .form-content-wrapper .non-clickable-select .choices__button {
      background: #d5e5fb!important;
      background-image: none!important;
      z-index: 999999;
      margin-right: 0px!important;
      width: 40px!important;
      opacity: 1!important;
    }
    .form-content-wrapper   div#stripe-card-element{
      height: 38px;
      position: relative;
      top: 4px;
      display:block!important;
    }
    @media screen and (min-width:769px){
      .signup-wrapper-container .form-content-wrapper .formio-form{
        display: flex;
        flex-wrap:wrap;
        justify-content: space-around;
        width:100%;
      }
      .form-content-wrapper .choices{
        width:100%!important;
      }
      .signup-wrapper-container .form-content-wrapper .form-group, #stripe-card-fields{
        width: 100%;
      }
    }
    
    .coupon-input {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
      margin-bottom: 1rem;
    }

    .coupon-apply-btn {
      height: 38px;
      margin: 0px !important;
    }

    @media screen and (max-width:769px){
      .block-wrapper-container {
        padding-left: 0px !important;
        padding-right: 0px !important;
      }
      .form-content-wrapper{
        padding:10px!important;
        font-size:14px!important;
        width: 100%!important;
        margin:auto;
      }
      .form-content-wrapper .form-group{
        margin-bottom:4px!important;
      }
    }
  `;

  const styleElement = document.createElement("style");
  styleElement.innerHTML = customCss;
  document.head.appendChild(styleElement);
});

// Stripe Init
export const signupSetupPayment = async (baseUrl, apiKey) => {
  const activeGW = await getGatewayActive(baseUrl, apiKey);
  if (activeGW.gateway_provider == 2) {
    let stripeApiKey = activeGW.credential_information.publishable_api_key;
    signupStripePayment(stripeApiKey, baseUrl, apiKey);
  }
};

// Load Stripe
async function signupStripePayment(stripeApiKey, baseUrl, apiKey) {
  const script_script = document.createElement("script");
  script_script.src = "https://js.stripe.com/v3/";
  script_script.async = true;

  script_script.addEventListener("load", () => {
    $(".formio-component-plan").after(`
      <div class="form-group has-feedback">
      <label for="stripe-card-element" class="col-form-label">Credit or debit card</label>
      <div id="stripe-card-fields">
      <div id="stripe-card-element" style="width:100%"></div>
      </div>
      </div>

      <div class="form-group has-feedback">
      <label for="coupon-code" class="col-form-label">Coupon Code</label>
      <div class="coupon-input">
      <input type="text" id="coupon-code" name="coupon_code" class="form-control"/>
      <button type="button" id="coupon_apply_btn" class="btn btn-primary coupon-apply-btn" style="margin-top: 5px;">Apply</button>
      </div>
      </div>
      `);

    stripe = Stripe(stripeApiKey);
    const elements = stripe.elements();
    cardElement = elements.create("card", {
      hidePostalCode: true,
    });
    cardElement.mount("#stripe-card-element");

    $("#coupon_apply_btn").on("click", async () => {
      const code = $("#coupon-code").val().trim();
      if (!selectedPlan?.uuid) {
        showAlert("Please select a plan first.");
        return;
      }
      if (!code) {
        showAlert("Enter a coupon code.");
        return;
      }
      await validateCouponCode(selectedPlan.uuid, code, baseUrl, apiKey);
    });
  });

  document.head.appendChild(script_script);

  if (plans.length === 1) {
    selectedPlan = plans[0];
    toggleStripeFields(selectedPlan.is_free);
  } else {
    $('select[name="data[plan]"]').change(function () {
      selectedPlan = plans.find((p) => p.uuid === this.value);
      toggleStripeFields(selectedPlan?.is_free);
    });
  }
}

function toggleStripeFields(isFree) {
  if (isFree) {
    $("#stripe-card-fields").hide();
  } else {
    $("#stripe-card-fields").show();
  }
}

async function stripeCard(payload) {
  const result = await stripe.createPaymentMethod({
    type: "card",
    card: cardElement,
    billing_details: {
      name: payload["userName"],
      email: payload["email"],
    },
  });

  if ("paymentMethod" in result) {
    return result.paymentMethod.id;
  } else {
    return null;
  }
}

async function validateCouponCode(planUUID, couponCode, baseUrl, tenantId) {
  try {
    const payload = JSON.stringify({
      plan_uuid: planUUID,
      offer_code: couponCode,
    });

    const res = await verifyCouponCode(baseUrl, tenantId, payload);

    if (res?.discounted_price) {
      showAlert(`Coupon applied! New price: $${res.discounted_price}`);
    } else {
      showAlert("Invalid or expired coupon code.");
    }
  } catch (err) {
    console.error("[Coupon] Error validating coupon:", err);
    showAlert("Error validating coupon code.");
  }
}

// You really shouldn't be here. This code is hell

export async function startCustomPaypalFlow({
  baseUrl,
  apiKey,
  client_id,
  client_secret,
  plan,
  firstName,
  lastName,
  email,
  password,
  onLogin, 
}) {
  try {
    const accessToken = await fetchPaypalAccessToken(baseUrl, apiKey, client_id, client_secret);

    const product = await checkOrCreatePaypalProduct(baseUrl, apiKey, accessToken, {
      id: plan.uuid,
      name: plan.title,
      description: plan.description,
      category: "Movie",
      image_url: 'https://example.com/default.jpg',
      home_url: `${window.location.origin}/thank-you.html`,
    });

    const planData = {
      product_id: product.product_id,
      name: plan.title,
      description: plan.description,
      regular_price: plan.price,
      currency: plan.price_currency,
      expires_in: plan.expires_in,
      trial_in: String(plan.trial_in || 0),
    };

    const subscriptionPlan = await createPaypalSubscriptionPlan(baseUrl, apiKey, accessToken, planData);

    const subscriptionData = {
      plan_id: subscriptionPlan.id,
      subscriber_name: `${firstName} ${lastName}`,
      email_address: email,
      return_url: `${window.location.origin}/thank-you.html`,
      cancel_url: `${window.location.origin}/thank-you.html`,
    };

    const subscription = await createPaypalSubscription(baseUrl, apiKey, accessToken, subscriptionData);

    const approvalUrl = subscription.links.find(link => link.rel === "approve")?.href;

    if (!approvalUrl) {
      showAlert("PayPal approval link not available.");
      return;
    }

    const popup = window.open(approvalUrl, "_blank", "width=600,height=800");

    if (!popup) {
      showAlert("Popup blocked! Please allow popups for this site to continue with PayPal.");
      return;
    }

    const interval = setInterval(async () => {
      if (popup.closed) {
        clearInterval(interval);

        const details = await getPaypalSubscriptionDetails(baseUrl, apiKey, accessToken, subscription.id);

        if (details?.status === "ACTIVE") {
          const payload = {
            subscriptionId: subscription.id,
            email,
            first_name: firstName,
            last_name: lastName,
            password,
            uuid: plan.uuid,
            subscriptionDetails: details,
          };

          const response = await purchaseSubscription(baseUrl, apiKey, JSON.stringify(payload));
          if (response?.credentials) {
            localStorage.setItem("loginToken", JSON.stringify(response.credentials));
            await onLogin();
          } else {
            showAlert("Subscription error. Please try again.");
          }
        } else {
          showAlert("Subscription is not active.");
        }
      }
    }, 500);
  } catch (err) {
    console.error("PayPal flow failed", err);
    showAlert("An error occurred during PayPal processing.");
  }
}
